import classes from './LandingSection.module.scss';
import Typewriter from 'typewriter-effect';

const LandingSection = () => {

  return (
    <section className={`${classes['landing-section']} pg-page pg-active`} id="home">
      <div className='bg-image-container'>
        <img src={require('assets/images/bg-landing.jpg')} alt="Landing background" />
      </div>
      <div className={classes['profile-image']}>
        <img src={require('assets/images/profile-pic.jpg')} alt="Marvin Jayson Baga" />
      </div>
      <div className={classes.author}>
        <p className={classes.intro}>Hello! I'm</p>
        <h1 className={classes['author-name']}>
          <span>Marvin Jayson</span>
          <span className='red'>Baga</span>
        </h1>
        <Typewriter
          options={{
            strings: ['Senior Web Developer', 'Full Stack Developer', 'Digital Consultant'],
            autoStart: true,
            loop: true,
          }}
        />
        <div className={classes.links}>
          <a className='btn' target='_blank' rel='noreferrer' href='https://www.linkedin.com/in/marvin-jayson-baga13' >
            <span>
              <i className='icon icon-linkedin'></i> 
              <span>LinkedIn</span>
            </span>
          </a>
          <a className='btn' target='_blank' rel='noreferrer' href='https://github.com/mjbaga' >
            <span>
              <i className='icon icon-github'></i> 
              <span>Github</span>
            </span>
          </a>
        </div>
        <p className={classes.email}>or email me at <a href="mailto:mjdbaga@gmail.com">mjdbaga@gmail.com</a></p>
        
      </div>
    </section>
  )
}

export default LandingSection;